import { FunctionComponent, useEffect } from "react";
import { useSelector } from "react-redux";
import { State } from "@App/state";
import { Loader } from "@App/Components/Loader";
import { useServiceFunnel } from "@App/hooks/useServiceFunnel";

export const RedirectToCatchAll: FunctionComponent = () => {
  const place = useSelector((state: State) => state.orders.place);
  const service = useSelector((state: State) => state.orders.service);
  const { navigateWithQuery } = useServiceFunnel("termin");

  // redirect to garage list if place is found
  useEffect(() => {
    if (!!place && !!service) {
      navigateWithQuery("termin/werkstaetten");
    }
  }, [place, service]);

  // redirect to catch all funnel beginning if no place or service is set after 5 seconds
  useEffect(() => {
    let redirectTimer = setTimeout(() => {
      navigateWithQuery("termin");
    }, 5000);

    return () => {
      clearTimeout(redirectTimer);
    };
  }, []);

  return (
    <div className="h-screen w-screen grid place-items-center">
      <Loader />
    </div>
  );
};
